import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../../services/api';
import {
  ForgotPasswordContainer,
  ForgotPasswordBox,
  ForgotPasswordTitle,
  ForgotPasswordDescription,
  ForgotPasswordForm,
  EmailInput,
  ButtonsContainer,
  SendButton,
  CancelButton,
  ErrorMessage,
  SuccessMessage,
  ResendLink,
  AlertModal,
  AlertModalContent,
  AlertModalButtons,
  OkButton
} from './styles';
import Loading from '../../../components/Loading';

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showResendLink, setShowResendLink] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please type your email');
      return;
    }
    
    setError('');
    setSuccess('');
    setIsLoading(true);
    
    try {
      // Chamada real à API para recuperação de senha usando a rota correta
      await api.get(`/api/auth/reset-password?email=${encodeURIComponent(email)}`);
      
      setSuccess('E-mail of recovery sent successfully!\nPlease check your email and follow the instructions.');
      setShowResendLink(true);
      // Não redirecionamos automaticamente para permitir a opção de reenvio
    } catch (err) {
      console.error('Erro ao solicitar recuperação de senha:', err);
      setError('Error processing your request. Try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleResend = async () => {
    if (!email) {
      setError('Please type your email');
      return;
    }
    
    setError('');
    setIsLoading(true);
    
    try {
      // Chamada real à API para reenvio usando a mesma rota
      await api.get(`/api/auth/reset-password?email=${encodeURIComponent(email)}`);
      
      // Exibimos o modal de confirmação
      setShowAlertModal(true);
    } catch (err) {
      console.error('Erro ao reenviar código:', err);
      setError('Error resending code. Try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/login');
  };

  const closeAlertModal = () => {
    setShowAlertModal(false);
  };

  return (
    <ForgotPasswordContainer>
      {isLoading && <Loading />}
      <ForgotPasswordBox>
        <ForgotPasswordTitle>Type your email</ForgotPasswordTitle>
        <ForgotPasswordDescription>
          We will send an email to reset your password
        </ForgotPasswordDescription>
        
        <ForgotPasswordForm onSubmit={handleSubmit}>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          {success && <SuccessMessage>{success}</SuccessMessage>}
          
          <EmailInput
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
          />
          
          
          
          <ButtonsContainer>
            <CancelButton 
              type="button" 
              onClick={handleCancel}
              disabled={isLoading}
            >
              Cancel
            </CancelButton>
            
            <SendButton 
              type="submit"
              disabled={isLoading}
            >
              Send
            </SendButton>
            
          </ButtonsContainer>
          {showResendLink && (
            <ResendLink 
              type="button"
              onClick={handleResend}
              disabled={isLoading}
            >
              Didn't receive the email?
            </ResendLink>
          )}
        </ForgotPasswordForm>
      </ForgotPasswordBox>

      {showAlertModal && (
        <AlertModal>
          <AlertModalContent>
            <h3>Code Resent</h3>
            <p>A new code of recovery was sent to your email.</p>
            <AlertModalButtons>
              <OkButton onClick={closeAlertModal}>
                OK
              </OkButton>
            </AlertModalButtons>
          </AlertModalContent>
        </AlertModal>
      )}
    </ForgotPasswordContainer>
  );
};

export default ResetPassword; 